export default __webpack_public_path__ + "static/media/img13.4798d352.PNG";